// extracted by mini-css-extract-plugin
module.exports = {"load-wait":"styles-m__load-wait__2bQVa","loader-image":"styles-m__loader-image__2zRrv"};